export const LEGAL_DOCS = {
  "terms": {
    "title": "Obchodní podmínky",
    "content": [
      {
        "type": "p",
        "text": "Internetový obchod WINORWINS na adrese winorwins.com. Účinné od 03. 10. 2026."
      },
      {
        "type": "h2",
        "text": "Článek 1 – Úvodní ustanovení a kontakty"
      },
      {
        "type": "li",
        "text": "Tyto obchodní podmínky (dále jen „podmínky”) upravují práva a povinnosti mezi prodávajícím a kupujícím při prodeji zboží prostřednictvím internetového obchodu na adrese winorwins.com (dále jen „e-shop”)."
      },
      {
        "type": "li",
        "text": "Prodávající: Dang Manh Nguyen, IČO 23161850, se sídlem Chudenická 1059/30, Hostivař, 102 00 Praha 10, fyzická osoba podnikající podle živnostenského zákona, zapsaná v živnostenském rejstříku. Prodávající není plátcem DPH."
      },
      {
        "type": "li",
        "text": "Kontakty: e-mail info@winorwins.com. Adresa pro vracení zboží a reklamace: Chudenická 1059/30, 102 00 Praha 10."
      },
      {
        "type": "li",
        "text": "Kupující – spotřebitel je člověk, který mimo rámec své podnikatelské činnosti nebo samostatného výkonu povolání uzavírá smlouvu s prodávajícím. Ustanovení o spotřebitelích se použijí jen na spotřebitele. Pro kupující-podnikatele platí odchylky uvedené v článku 12."
      },
      {
        "type": "li",
        "text": "Smlouvu lze uzavřít v českém jazyce a anglickém jazyce."
      },
      {
        "type": "li",
        "text": "Prodávající může tyto podmínky měnit. Na kupní smlouvu se vždy použije znění účinné v okamžiku odeslání objednávky."
      },
      {
        "type": "h2",
        "text": "Článek 2 – Zboží a ceny"
      },
      {
        "type": "li",
        "text": "Prezentace zboží v e-shopu má informativní povahu a není návrhem na uzavření smlouvy. Ustanovení § 1732 odst. 2 občanského zákoníku se nepoužije."
      },
      {
        "type": "li",
        "text": "Ceny zboží jsou uvedeny jako konečné, včetně všech poplatků. Prodávající není plátcem DPH. Náklady na dopravu a zvolený způsob platby se zobrazí před odesláním objednávky a jsou uvedeny také v dokumentu Doprava a doručení."
      },
      {
        "type": "li",
        "text": "U každého zboží uvádíme materiálové složení, pokyny k údržbě a velikostní tabulku. Barevné odstíny na fotografiích se mohou mírně lišit podle nastavení displeje."
      },
      {
        "type": "li",
        "text": "Slevy: u každého oznámení o slevě uvádíme také nejnižší cenu, za kterou jsme zboží nabízeli v období 30 dnů před slevou."
      },
      {
        "type": "li",
        "text": "Personalizace ceny: Ceny v e-shopu nejsou personalizovány na základě automatizovaného rozhodování."
      },
      {
        "type": "li",
        "text": "Akční nabídky platí po dobu uvedenou u akce, nebo do vyprodání zásob."
      },
      {
        "type": "h2",
        "text": "Článek 3 – Objednávka a uzavření kupní smlouvy"
      },
      {
        "type": "li",
        "text": "Kupující vybere zboží a velikost, vloží je do košíku, vyplní kontaktní a doručovací údaje, zvolí dopravu a platbu a objednávku odešle tlačítkem „Objednávka zavazující k platbě”. Před odesláním může údaje v objednávce zkontrolovat a opravit."
      },
      {
        "type": "li",
        "text": "Odeslání objednávky potvrdíme automatickým e-mailem o jejím přijetí. Kupní smlouva je uzavřena okamžikem doručení e-mailu „Potvrzení objednávky”, kterým objednávku přijímáme. Jeho přílohou jsou tyto podmínky v PDF."
      },
      {
        "type": "li",
        "text": "Uzavřenou smlouvu archivujeme v elektronické podobě po dobu 10 let a třetím osobám ji nezpřístupňujeme."
      },
      {
        "type": "li",
        "text": "Náklady na komunikaci na dálku (internet, telefon) hradí kupující a neliší se od základní sazby jeho operátora."
      },
      {
        "type": "li",
        "text": "Při pochybnostech o pravosti objednávky nebo při nedostupnosti zboží můžeme kupujícího před přijetím objednávky kontaktovat a požádat o potvrzení nebo objednávku nepřijmout."
      },
      {
        "type": "li",
        "text": "Zákaznický účet je dobrovolný. Kupující je povinen chránit své přihlašovací údaje. Účet lze kdykoli zrušit e-mailem na info@winorwins.com nebo v nastavení účtu."
      },
      {
        "type": "h2",
        "text": "Článek 4 – Platební podmínky"
      },
      {
        "type": "li",
        "text": "Kupní cenu lze uhradit: online platební kartou přes zabezpečenou platební bránu Teya."
      },
      {
        "type": "li",
        "text": "Údaje o platebních kartách nezpracováváme; platbu zpracovává poskytovatel platební brány."
      },
      {
        "type": "li",
        "text": "Doklad o zaplacení zasíláme e-mailem po zaplacení."
      },
      {
        "type": "h2",
        "text": "Článek 5 – Doprava a dodání"
      },
      {
        "type": "li",
        "text": "Způsoby, ceny a lhůty dopravy jsou uvedeny v dokumentu Doprava a doručení, který je součástí těchto podmínek."
      },
      {
        "type": "li",
        "text": "Zboží skladem odesíláme obvykle do 1–2 pracovních dnů od uzavření smlouvy (u platby předem od připsání platby). Nejpozději zboží dodáme do 30 dnů od uzavření smlouvy, nebylo-li dohodnuto jinak."
      },
      {
        "type": "li",
        "text": "Nebezpečí škody na zboží přechází na kupujícího-spotřebitele okamžikem, kdy zboží převezme od dopravce. Vlastnické právo přechází zaplacením kupní ceny a převzetím zboží."
      },
      {
        "type": "li",
        "text": "Nevyzvedne-li kupující zásilku, máme právo na náhradu skutečně vynaložených nákladů na doručení a vrácení zásilky a můžeme od smlouvy odstoupit. Zaplacenou kupní cenu vrátíme po odečtení těchto nákladů."
      },
      {
        "type": "h2",
        "text": "Článek 6 – Odstoupení od smlouvy spotřebitelem (vrácení do 14 dnů)"
      },
      {
        "type": "li",
        "text": "Spotřebitel může od kupní smlouvy odstoupit bez udání důvodu do 14 dnů od převzetí zboží. Je-li objednávka dodána v několika částech, lhůta běží od převzetí poslední části. Odstoupit lze i před převzetím zboží."
      },
      {
        "type": "li",
        "text": "Odstoupení lze provést jakýmkoli jednoznačným prohlášením, zejména:"
      },
      {
        "type": "li",
        "text": "e-mailem na info@winorwins.com,"
      },
      {
        "type": "li",
        "text": "dopisem na adresu Chudenická 1059/30, 102 00 Praha 10,"
      },
      {
        "type": "li",
        "text": "vzorovým formulářem, který je přílohou těchto podmínek (použití není povinné)."
      },
      {
        "type": "li",
        "text": "Lhůta je zachována, pokud spotřebitel odešle odstoupení před jejím uplynutím. Přijetí odstoupení potvrdíme bez zbytečného odkladu e-mailem, včetně jeho obsahu a data a času odeslání."
      },
      {
        "type": "li",
        "text": "Zboží je třeba nám zaslat nebo předat do 14 dnů od odstoupení na adresu Chudenická 1059/30, 102 00 Praha 10, ne na dobírku. Náklady na vrácení zboží nese spotřebitel."
      },
      {
        "type": "li",
        "text": "Peníze vrátíme do 14 dnů od odstoupení, včetně nákladů na dodání zboží v nejlevnějším nabízeném způsobu dopravy. Peníze vracíme stejným způsobem, jakým byly přijaty, pokud se nedohodneme jinak a spotřebiteli tím nevzniknou další náklady. Peníze nejsme povinni vrátit dříve, než nám zboží dojde nebo spotřebitel prokáže, že je odeslal."
      },
      {
        "type": "li",
        "text": "Zboží je možné vyzkoušet tak, jako by to bylo možné v kamenném obchodě. Spotřebitel odpovídá za snížení hodnoty zboží vzniklé nakládáním nad tento rámec (např. nošení, praní, poškození, znečištění, zápach parfému či kouře). Náhradu snížení hodnoty můžeme jednostranně započíst proti nároku na vrácení kupní ceny. Doporučujeme ponechat visačky a vrátit zboží v původním obalu."
      },
      {
        "type": "li",
        "text": "Odstoupit nelze od smlouvy na:"
      },
      {
        "type": "li",
        "text": "zboží upravené podle přání spotřebitele (např. potisk, výšivka nebo úprava na zakázku),"
      },
      {
        "type": "li",
        "text": "zboží dodané v zapečetěném obalu, které nelze z hygienických důvodů vrátit poté, co spotřebitel obal porušil."
      },
      {
        "type": "li",
        "text": "Byl-li ke zboží poskytnut dárek, je darovací smlouva uzavřena s rozvazovací podmínkou: odstoupí-li spotřebitel od kupní smlouvy, pozbývá darovací smlouva účinnosti a dárek je třeba vrátit spolu se zbožím."
      },
      {
        "type": "li",
        "text": "Výměna velikosti není zákonnou povinností. Nabízíme ji takto: vrácením zboží postupem podle tohoto článku a novou objednávkou."
      },
      {
        "type": "h2",
        "text": "Článek 7 – Odstoupení od smlouvy prodávajícím"
      },
      {
        "type": "li",
        "text": "Do odeslání zboží můžeme od smlouvy odstoupit, pokud zboží již nelze dodat (vyprodání, ukončení výroby) nebo pokud byla v e-shopu v důsledku technické chyby uvedena zjevně chybná cena, která neodpovídá obvyklé ceně zboží."
      },
      {
        "type": "li",
        "text": "Odstoupení oznámíme kupujícímu e-mailem a přijatou platbu vrátíme bez zbytečného odkladu, nejpozději do 14 dnů."
      },
      {
        "type": "h2",
        "text": "Článek 8 – Práva z vadného plnění (reklamace)"
      },
      {
        "type": "li",
        "text": "Odpovídáme za to, že zboží při převzetí nemá vady. U spotřebitele lze vadu uplatnit do 24 měsíců od převzetí zboží. Projeví-li se vada během jednoho roku od převzetí, má se za to, že zboží bylo vadné již při převzetí."
      },
      {
        "type": "li",
        "text": "Reklamaci vyřídíme nejpozději do 30 dnů od jejího uplatnění, pokud se se spotřebitelem nedohodneme na delší lhůtě."
      },
      {
        "type": "li",
        "text": "Podrobnosti o právech z vadného plnění, postupu a o tom, co se za vadu nepovažuje, upravuje Reklamační řád v dokumentu Vrácení zboží a reklamace, který je součástí těchto podmínek."
      },
      {
        "type": "h2",
        "text": "Článek 9 – Osobní údaje, obchodní sdělení a cookies"
      },
      {
        "type": "li",
        "text": "Zpracování osobních údajů upravuje dokument Zásady ochrany osobních údajů."
      },
      {
        "type": "li",
        "text": "Používání cookies upravuje dokument Zásady používání cookies. Souhlas s nepovinnými cookies lze kdykoli změnit odkazem „Nastavení cookies” v patičce webu."
      },
      {
        "type": "li",
        "text": "Obchodní sdělení zasíláme jen se souhlasem, nebo zákazníkům ohledně obdobného zboží. Odhlásit se lze kdykoli odkazem v každém e-mailu."
      },
      {
        "type": "h2",
        "text": "Článek 10 – Stížnosti a mimosoudní řešení sporů"
      },
      {
        "type": "li",
        "text": "Stížnosti vyřizujeme na e-mailu info@winorwins.com. Odpovíme do 5 pracovních dnů."
      },
      {
        "type": "li",
        "text": "K mimosoudnímu řešení spotřebitelských sporů z kupní smlouvy je příslušná Česká obchodní inspekce, Ústřední inspektorát – oddělení ADR, Štěpánská 796/44, 110 00 Praha 1, www.adr.coi.cz."
      },
      {
        "type": "li",
        "text": "Spotřebitel z jiného státu EU se může obrátit na Evropské spotřebitelské centrum ČR (www.evropskespotrebitelskecentrum.cz)."
      },
      {
        "type": "li",
        "text": "Dozor nad dodržováním povinností vykonává Česká obchodní inspekce (www.coi.gov.cz), v oblasti osobních údajů Úřad pro ochranu osobních údajů (www.uoou.gov.cz) a v rozsahu živnostenského oprávnění příslušný živnostenský úřad."
      },
      {
        "type": "h2",
        "text": "Článek 11 – Vyšší moc"
      },
      {
        "type": "p",
        "text": "Neodpovídáme za prodlení způsobené okolnostmi, které nemůžeme ovlivnit (např. výpadky dopravců, přírodní události, stávky). O prodlení kupujícího bez zbytečného odkladu informujeme."
      },
      {
        "type": "h2",
        "text": "Článek 12 – Kupující – podnikatel"
      },
      {
        "type": "li",
        "text": "Na kupujícího, který nakupuje v rámci své podnikatelské činnosti (uvede IČO), se nepoužijí ustanovení o odstoupení od smlouvy podle článku 6 ani ustanovení chránící spotřebitele."
      },
      {
        "type": "li",
        "text": "Práva z vadného plnění se řídí § 2099 a násl. občanského zákoníku. Vadu je kupující-podnikatel povinen oznámit bez zbytečného odkladu, nejpozději do 6 měsíců od převzetí zboží."
      },
      {
        "type": "li",
        "text": "Nebezpečí škody přechází na kupujícího-podnikatele předáním zboží prvnímu dopravci."
      },
      {
        "type": "h2",
        "text": "Článek 13 – Závěrečná ustanovení"
      },
      {
        "type": "li",
        "text": "Vztahy neupravené těmito podmínkami se řídí českým právem, zejména zákonem č. 89/2012 Sb., občanský zákoník, a zákonem č. 634/1992 Sb., o ochraně spotřebitele. Volbou práva není spotřebitel zbaven ochrany, kterou mu poskytují kogentní ustanovení práva státu jeho obvyklého pobytu."
      },
      {
        "type": "li",
        "text": "Je-li některé ustanovení neplatné, ostatní ustanovení zůstávají v platnosti."
      },
      {
        "type": "li",
        "text": "Součástí těchto podmínek jsou dokumenty Vrácení zboží a reklamace, Doprava a doručení a vzorový formulář pro odstoupení od smlouvy."
      },
      {
        "type": "li",
        "text": "Tyto podmínky nabývají účinnosti dnem 03. 10. 2026."
      },
      {
        "type": "h2",
        "text": "Příloha – Vzorový formulář pro odstoupení od smlouvy"
      },
      {
        "type": "p",
        "text": "(vyplňte tento formulář a pošlete jej zpět pouze v případě, že chcete odstoupit od smlouvy)"
      },
      {
        "type": "p",
        "text": "Adresát: Dang Manh Nguyen, IČO 23161850, Chudenická 1059/30, Hostivař, 102 00 Praha 10, e-mail info@winorwins.com"
      },
      {
        "type": "p",
        "text": "Oznamuji/oznamujeme (*), že tímto odstupuji/odstupujeme (*) od smlouvy o nákupu tohoto zboží:"
      },
      {
        "type": "li",
        "text": "Číslo objednávky: ………………………………"
      },
      {
        "type": "li",
        "text": "Zboží: ………………………………"
      },
      {
        "type": "li",
        "text": "Datum objednání (*) / datum obdržení (*): ………………………………"
      },
      {
        "type": "li",
        "text": "Jméno a příjmení spotřebitele/spotřebitelů: ………………………………"
      },
      {
        "type": "li",
        "text": "Adresa spotřebitele/spotřebitelů: ………………………………"
      },
      {
        "type": "li",
        "text": "E-mail / telefon: ………………………………"
      },
      {
        "type": "li",
        "text": "Číslo účtu pro vrácení peněz (nepovinné): ………………………………"
      },
      {
        "type": "li",
        "text": "Podpis spotřebitele/spotřebitelů (pouze pokud je formulář zasílán v listinné podobě): ………………………………"
      },
      {
        "type": "li",
        "text": "Datum: ………………………………"
      },
      {
        "type": "p",
        "text": "(*) Nehodící se škrtněte nebo údaje doplňte."
      }
    ]
  },
  "refund": {
    "title": "Vrácení zboží a reklamace",
    "content": [
      {
        "type": "p",
        "text": "Nesedí velikost nebo se vám věc nelíbí? Máte 14 dnů od převzetí na vrácení bez udání důvodu. Na vadné zboží se vztahuje 24měsíční odpovědnost za vady. Tento dokument je součástí obchodních podmínek e-shopu WINORWINS, provozovaného podnikatelem Dang Manh Nguyen, IČO 23161850, se sídlem Chudenická 1059/30, Hostivař, 102 00 Praha 10."
      },
      {
        "type": "h2",
        "text": "Část A – Vrácení zboží do 14 dnů"
      },
      {
        "type": "h3",
        "text": "Jak vrátit zboží"
      },
      {
        "type": "li",
        "text": "Zabalte zboží – nejlépe v původním obalu, s visačkami. Přiložte číslo objednávky."
      },
      {
        "type": "li",
        "text": "Odešlete zásilku do 14 dnů od oznámení na adresu: Dang Manh Nguyen, Chudenická 1059/30, 102 00 Praha 10. Zásilky na dobírku nepřijímáme."
      },
      {
        "type": "li",
        "text": "Peníze vrátíme do 14 dnů od doručení vašeho odstoupení, nejdříve však po obdržení zboží (nebo dokladu o jeho odeslání)."
      },
      {
        "type": "h3",
        "text": "Co vám vrátíme"
      },
      {
        "type": "li",
        "text": "Celou kupní cenu vráceného zboží."
      },
      {
        "type": "li",
        "text": "Poštovné za doručení k vám ve výši nejlevnějšího nabízeného způsobu dopravy (vracíte-li celou objednávku)."
      },
      {
        "type": "li",
        "text": "Peníze pošleme stejnou cestou, jakou jste platili (karta → zpět na kartu). Jiný způsob jen po dohodě s vámi."
      },
      {
        "type": "li",
        "text": "Poštovné za zaslání zboží zpět hradíte vy."
      },
      {
        "type": "h3",
        "text": "Stav vraceného zboží"
      },
      {
        "type": "p",
        "text": "Oblečení si můžete vyzkoušet stejně jako v kabince. Pokud vrácená věc nese stopy nošení, praní, znečištění, poškození nebo zápachu (parfém, kouř), máme právo na náhradu snížení její hodnoty. Tuto částku můžeme odečíst od vracených peněz. O odpočtu vás vždy předem informujeme i s odůvodněním."
      },
      {
        "type": "h3",
        "text": "Co nelze vrátit"
      },
      {
        "type": "li",
        "text": "Zboží upravené podle vašeho přání (potisk, výšivka, úprava na míru)."
      },
      {
        "type": "h3",
        "text": "Výměna velikosti"
      },
      {
        "type": "p",
        "text": "Výměnu velikosti vyřídíte e-mailem na info@winorwins.com — uveďte číslo objednávky a požadovanou velikost. Novou velikost odešleme, jakmile nám dorazí původní kus. Není-li velikost skladem, vrátíme peníze."
      },
      {
        "type": "h2",
        "text": "Část B – Reklamační řád"
      },
      {
        "type": "h3",
        "text": "1. Rozsah odpovědnosti"
      },
      {
        "type": "li",
        "text": "Odpovídáme za to, že zboží při převzetí nemá vady, zejména že odpovídá popisu, velikosti a materiálovému složení uvedenému v e-shopu, je vhodné k obvyklému účelu a je dodáno ve správném množství."
      },
      {
        "type": "li",
        "text": "Spotřebitel může vadu uplatnit, pokud se projeví do 24 měsíců od převzetí zboží."
      },
      {
        "type": "li",
        "text": "Projeví-li se vada do jednoho roku od převzetí, má se za to, že zboží bylo vadné již při převzetí, ledaže to povaha zboží nebo vady vylučuje."
      },
      {
        "type": "h3",
        "text": "2. Co není vadou"
      },
      {
        "type": "li",
        "text": "Běžné opotřebení odpovídající délce a intenzitě používání."
      },
      {
        "type": "li",
        "text": "Poškození způsobené nedodržením symbolů údržby na etiketě (praní při vyšší teplotě, sušička, žehlení, chemické čištění)."
      },
      {
        "type": "li",
        "text": "Mechanické poškození (protržení, propal, zachycení o ostrý předmět) způsobené kupujícím."
      },
      {
        "type": "li",
        "text": "Vlastnosti materiálu, na které jsme v popisu zboží upozornili (např. mírné sražení bavlny v uvedené toleranci, mačkavost lnu, přirozené blednutí u praných úprav)."
      },
      {
        "type": "li",
        "text": "Vada, o které jste před převzetím věděli, nebo kvůli které byla poskytnuta sleva."
      },
      {
        "type": "h3",
        "text": "3. Vaše práva při vadě"
      },
      {
        "type": "li",
        "text": "Můžete požadovat opravu nebo výměnu za nový kus. Zvolený způsob můžeme odmítnout, jen pokud je nemožný nebo ve srovnání s druhým nepřiměřeně nákladný."
      },
      {
        "type": "li",
        "text": "Přiměřenou slevu nebo odstoupení od smlouvy můžete požadovat, pokud:"
      },
      {
        "type": "li",
        "text": "opravu ani výměnu odmítneme nebo je neprovedeme včas a bez značných obtíží,"
      },
      {
        "type": "li",
        "text": "se vada projeví opakovaně,"
      },
      {
        "type": "li",
        "text": "je vada podstatným porušením smlouvy,"
      },
      {
        "type": "li",
        "text": "je z našeho prohlášení nebo okolností zřejmé, že vadu neodstraníme včas nebo bez značných obtíží."
      },
      {
        "type": "li",
        "text": "Je-li vada nevýznamná, od smlouvy odstoupit nelze; máte však právo na slevu."
      },
      {
        "type": "h3",
        "text": "4. Jak reklamovat"
      },
      {
        "type": "li",
        "text": "Kontaktujte nás na info@winorwins.com. Uveďte číslo objednávky, popis vady, ideálně fotografie, a jaké řešení požadujete."
      },
      {
        "type": "li",
        "text": "Zboží zašlete na adresu Dang Manh Nguyen, Chudenická 1059/30, 102 00 Praha 10. Zboží by mělo být čisté (z hygienických důvodů)."
      },
      {
        "type": "li",
        "text": "Reklamaci uplatňujte bez zbytečného odkladu poté, co vadu zjistíte."
      },
      {
        "type": "li",
        "text": "Při uplatnění reklamace vám vydáme potvrzení s datem uplatnění, popisem vady a požadovaným způsobem vyřízení."
      },
      {
        "type": "h3",
        "text": "5. Vyřízení reklamace"
      },
      {
        "type": "li",
        "text": "Reklamaci vyřídíme včetně odstranění vady nejpozději do 30 dnů od jejího uplatnění, nedohodneme-li se s vámi na delší lhůtě."
      },
      {
        "type": "li",
        "text": "O vyřízení vás informujeme e-mailem a vydáme potvrzení o datu a způsobu vyřízení, včetně potvrzení o provedení opravy a době jejího trvání, případně písemné odůvodnění zamítnutí."
      },
      {
        "type": "li",
        "text": "U oprávněné reklamace vám uhradíme účelně vynaložené náklady na zaslání zboží."
      },
      {
        "type": "li",
        "text": "Při výměně zboží nám vadné zboží vrátíte na naše náklady."
      },
      {
        "type": "li",
        "text": "Peníze při slevě nebo odstoupení vracíme bez zbytečného odkladu, nejpozději do 14 dnů."
      },
      {
        "type": "h3",
        "text": "6. Kupující – podnikatel"
      },
      {
        "type": "p",
        "text": "Na kupující, kteří nakupují v rámci podnikání, se nepoužijí lhůty a domněnky chránící spotřebitele; postup se řídí článkem 12 obchodních podmínek."
      },
      {
        "type": "h3",
        "text": "7. Mimosoudní řešení sporů"
      },
      {
        "type": "p",
        "text": "Nejste-li s vyřízením reklamace spokojeni, můžete se obrátit na Českou obchodní inspekci, oddělení ADR, Štěpánská 796/44, 110 00 Praha 1, www.adr.coi.cz."
      },
      {
        "type": "p",
        "text": "Tento reklamační řád je účinný od 03. 10. 2026."
      }
    ]
  },
  "shipping": {
    "title": "Doprava a doručení",
    "content": [
      {
        "type": "p",
        "text": "Zboží skladem odesíláme do 1–2 pracovních dnů přes DPD, na adresu nebo do DPD boxu. Tento dokument je součástí obchodních podmínek e-shopu WINORWINS."
      },
      {
        "type": "h2",
        "text": "Expedice"
      },
      {
        "type": "li",
        "text": "Objednávky zaplacené do 12:00 v pracovní den odesíláme týž den."
      },
      {
        "type": "li",
        "text": "Zboží na předobjednávku nebo na zakázku odesíláme v termínu uvedeném u produktu."
      },
      {
        "type": "li",
        "text": "Obsahuje-li objednávka zboží skladem i na předobjednávku, odešleme ji najednou, až bude vše k dispozici."
      },
      {
        "type": "li",
        "text": "Nejpozději zboží dodáme do 30 dnů od uzavření smlouvy, nebylo-li dohodnuto jinak."
      },
      {
        "type": "li",
        "text": "O odeslání vás informujeme e-mailem s odkazem na sledování zásilky."
      },
      {
        "type": "h2",
        "text": "Způsoby a ceny dopravy – Česká republika"
      },
      {
        "type": "table",
        "rows": [
          [
            "Způsob dopravy",
            "Doručení po odeslání",
            "Cena"
          ],
          [
            "DPD – doručení do boxu nebo na výdejní místo",
            "1–2 pracovní dny",
            "79 Kč"
          ],
          [
            "DPD – doručení na adresu",
            "1–2 pracovní dny",
            "89 Kč"
          ]
        ]
      },
      {
        "type": "p",
        "text": "DPD box nebo výdejní místo si vyberete na mapě v pokladně. Platba probíhá předem kartou, dobírku nenabízíme."
      },
      {
        "type": "h2",
        "text": "Doprava na Slovensko a do EU"
      },
      {
        "type": "table",
        "rows": [
          [
            "Země",
            "Způsob dopravy",
            "Doručení po odeslání",
            "Cena"
          ],
          [
            "Slovensko",
            "DPD – box nebo na adresu",
            "2–3 pracovní dny",
            "zobrazí se v pokladně"
          ],
          [
            "Ostatní státy EU",
            "Kurýr",
            "3–7 pracovních dnů",
            "podle země, zobrazí se v košíku"
          ]
        ]
      },
      {
        "type": "p",
        "text": "Mimo EU nedoručujeme."
      },
      {
        "type": "p",
        "text": "Uvedené doby doručení jsou obvyklé lhůty dopravců; v období svátků a výprodejů se mohou prodloužit."
      },
      {
        "type": "h2",
        "text": "Převzetí zásilky"
      },
      {
        "type": "li",
        "text": "Při převzetí zkontrolujte neporušenost obalu."
      },
      {
        "type": "li",
        "text": "Je-li obal zjevně poškozen, zásilku nepřebírejte, nebo s dopravcem sepište záznam o poškození. Dejte nám vědět na info@winorwins.com a přiložte fotografie."
      },
      {
        "type": "li",
        "text": "Převzetím zásilky na vás přechází nebezpečí škody na zboží. Vaše práva z vadného plnění a právo vrátit zboží do 14 dnů tím nejsou dotčena."
      },
      {
        "type": "h2",
        "text": "Nevyzvednutá zásilka"
      },
      {
        "type": "li",
        "text": "Zásilka čeká v DPD boxu nebo na výdejním místě po dobu uložení podle dopravce (obvykle 7 dní)."
      },
      {
        "type": "li",
        "text": "Nevyzvednete-li zásilku, můžeme od smlouvy odstoupit a požadovat náhradu skutečně vynaložených nákladů na doručení a vrácení zásilky. U zaplacené objednávky tuto částku odečteme od vracených peněz."
      },
      {
        "type": "li",
        "text": "O opětovné odeslání nás můžete požádat; poštovné za nové doručení hradíte vy."
      },
      {
        "type": "h2",
        "text": "Změna adresy a ztráta zásilky"
      },
      {
        "type": "li",
        "text": "Změnu doručovací adresy nám napište co nejdříve; po odeslání ji lze změnit jen přes dopravce, pokud to umožňuje."
      },
      {
        "type": "li",
        "text": "Pokud zásilka nedorazí do 7 pracovních dnů od odeslání, kontaktujte nás. Ztracenou zásilku za vás řešíme s dopravcem a pošleme náhradní zboží nebo vrátíme peníze."
      },
      {
        "type": "h2",
        "text": "Kontakt"
      },
      {
        "type": "p",
        "text": "Dang Manh Nguyen, IČO 23161850, Chudenická 1059/30, Hostivař, 102 00 Praha 10, info@winorwins.com."
      },
      {
        "type": "p",
        "text": "Účinné od 03. 10. 2026."
      }
    ]
  },
  "privacy": {
    "title": "Ochrana osobních údajů",
    "content": [
      {
        "type": "p",
        "text": "Osobní údaje zpracováváme hlavně proto, abychom vám mohli doručit objednávku, a jen v rozsahu, který je k tomu nutný. Tyto zásady vysvětlují, jak s údaji nakládáme podle nařízení (EU) 2016/679 (GDPR) a zákona č. 110/2019 Sb., o zpracování osobních údajů."
      },
      {
        "type": "h2",
        "text": "1. Správce"
      },
      {
        "type": "p",
        "text": "Dang Manh Nguyen, IČO 23161850, se sídlem Chudenická 1059/30, Hostivař, 102 00 Praha 10, provozovatel e-shopu winorwins.com (dále „my”)."
      },
      {
        "type": "p",
        "text": "Kontakt pro ochranu osobních údajů: info@winorwins.com. Pověřence pro ochranu osobních údajů jsme nejmenovali, protože nám tato povinnost nevzniká."
      },
      {
        "type": "h2",
        "text": "2. Proč a na základě čeho údaje zpracováváme"
      },
      {
        "type": "table",
        "rows": [
          [
            "Účel",
            "Údaje",
            "Právní základ",
            "Jak dlouho"
          ],
          [
            "Vyřízení objednávky, doprava, vrácení zboží, reklamace",
            "jméno, příjmení, doručovací a fakturační adresa, e-mail, telefon, obsah objednávky, údaje o platbě",
            "plnění smlouvy (čl. 6 odst. 1 písm. b) GDPR)",
            "po dobu plnění smlouvy a dále 4 roky kvůli promlčecím lhůtám"
          ],
          [
            "Účetnictví a daně",
            "fakturační údaje, IČO/DIČ",
            "právní povinnost (čl. 6 odst. 1 písm. c) GDPR)",
            "10 let podle daňových a účetních předpisů"
          ],
          [
            "Zákaznický účet",
            "přihlašovací údaje, historie objednávek, uložené adresy",
            "plnění smlouvy (čl. 6 odst. 1 písm. b) GDPR)",
            "do zrušení účtu"
          ],
          [
            "Obchodní sdělení stávajícím zákazníkům (obdobné zboží)",
            "e-mail, jméno, historie nákupů",
            "oprávněný zájem (čl. 6 odst. 1 písm. f) GDPR) a § 7 odst. 3 zákona č. 480/2004 Sb.",
            "do odhlášení, nejdéle 3 roky od posledního nákupu"
          ],
          [
            "Newsletter pro ostatní zájemce",
            "e-mail, jméno",
            "souhlas (čl. 6 odst. 1 písm. a) GDPR)",
            "do odvolání souhlasu"
          ],
          [
            "Dotazník spokojenosti a recenze Heureka Ověřeno zákazníky",
            "e-mail, obsah objednávky",
            "oprávněný zájem (čl. 6 odst. 1 písm. f) GDPR); lze odmítnout při objednávce",
            "do odeslání dotazníku"
          ],
          [
            "Analytika a remarketing (cookies)",
            "online identifikátory, chování na webu",
            "souhlas (čl. 6 odst. 1 písm. a) GDPR)",
            "viz Zásady používání cookies"
          ],
          [
            "Zákaznická podpora a komunikace (e-mail, chat, sociální sítě)",
            "jméno, kontakt, obsah zprávy",
            "oprávněný zájem (čl. 6 odst. 1 písm. f) GDPR)",
            "2 roky od poslední komunikace"
          ],
          [
            "Ochrana právních nároků a prevence podvodů",
            "údaje z objednávky, IP adresa",
            "oprávněný zájem (čl. 6 odst. 1 písm. f) GDPR)",
            "po dobu trvání nároku"
          ],
          [
            "Soutěže na sociálních sítích",
            "jméno, uživatelské jméno, doručovací údaje výherce",
            "plnění soutěžních podmínek",
            "do ukončení soutěže a předání výhry"
          ]
        ]
      },
      {
        "type": "p",
        "text": "Poskytnutí údajů potřebných k vyřízení objednávky je smluvním požadavkem; bez nich objednávku vyřídit nemůžeme. Ostatní údaje jsou dobrovolné."
      },
      {
        "type": "h2",
        "text": "3. Komu údaje předáváme"
      },
      {
        "type": "p",
        "text": "Údaje předáváme jen tomu, kdo je potřebuje k provedení služby pro nás (zpracovatelům), nebo pokud to vyžaduje zákon:"
      },
      {
        "type": "li",
        "text": "provozovatel e-shopové platformy a hostingu: Shopify,"
      },
      {
        "type": "li",
        "text": "poskytovatel platební brány: Teya (platební brána),"
      },
      {
        "type": "li",
        "text": "dopravce: DPD (Direct Parcel Distribution CZ s.r.o.),"
      },
      {
        "type": "li",
        "text": "účetní a daňoví poradci: název účetní firmy,"
      },
      {
        "type": "li",
        "text": "nástroj pro rozesílání e-mailů: Ecomail,"
      },
      {
        "type": "li",
        "text": "analytické a reklamní služby (jen se souhlasem): Google, Meta, TikTok,"
      },
      {
        "type": "li",
        "text": "služby pro recenze: Heureka,"
      },
      {
        "type": "li",
        "text": "státní orgány, pokud to vyžaduje zákon."
      },
      {
        "type": "p",
        "text": "Na našich profilech na sociálních sítích (Instagram, Facebook, TikTok) jsme ve vztahu ke statistikám stránky společnými správci s provozovatelem dané sítě. Zpracování údajů samotnou sítí se řídí jejími zásadami."
      },
      {
        "type": "h2",
        "text": "4. Předání mimo EU"
      },
      {
        "type": "p",
        "text": "Někteří naši dodavatelé (Google, Meta, Klaviyo, Shopify) mohou údaje zpracovávat v USA. Předání probíhá na základě rozhodnutí Evropské komise o odpovídající ochraně (EU–US Data Privacy Framework) nebo standardních smluvních doložek."
      },
      {
        "type": "h2",
        "text": "5. Automatizované rozhodování a profilování"
      },
      {
        "type": "p",
        "text": "Neprovádíme automatizované rozhodování s právními účinky. Personalizovanou reklamu na základě vašeho chování na webu zobrazujeme jen s vaším souhlasem s marketingovými cookies."
      },
      {
        "type": "h2",
        "text": "6. Vaše práva"
      },
      {
        "type": "p",
        "text": "Máte právo:"
      },
      {
        "type": "li",
        "text": "na přístup ke svým údajům a kopii,"
      },
      {
        "type": "li",
        "text": "na opravu nepřesných údajů,"
      },
      {
        "type": "li",
        "text": "na výmaz, pokud údaje už nepotřebujeme nebo je zpracováváme protiprávně,"
      },
      {
        "type": "li",
        "text": "na omezení zpracování,"
      },
      {
        "type": "li",
        "text": "na přenositelnost údajů, které zpracováváme na základě smlouvy nebo souhlasu,"
      },
      {
        "type": "li",
        "text": "vznést námitku proti zpracování na základě oprávněného zájmu; proti přímému marketingu vždy s okamžitým účinkem,"
      },
      {
        "type": "li",
        "text": "kdykoli odvolat souhlas, aniž by tím byla dotčena zákonnost předchozího zpracování,"
      },
      {
        "type": "li",
        "text": "podat stížnost u Úřadu pro ochranu osobních údajů, Pplk. Sochora 27, 170 00 Praha 7, www.uoou.gov.cz."
      },
      {
        "type": "p",
        "text": "Svá práva uplatněte na info@winorwins.com. Odpovíme bez zbytečného odkladu, nejpozději do jednoho měsíce. Z newsletteru se odhlásíte odkazem v každém e-mailu."
      },
      {
        "type": "h2",
        "text": "7. Zabezpečení"
      },
      {
        "type": "p",
        "text": "Údaje chráníme technickými a organizačními opatřeními: šifrované spojení (HTTPS), řízení přístupu, dvoufázové ověření u administrace a smlouvy o zpracování se všemi zpracovateli. Údaje o platebních kartách neukládáme."
      },
      {
        "type": "h2",
        "text": "8. Děti"
      },
      {
        "type": "p",
        "text": "E-shop není určen osobám mladším 15 let. Souhlas s newsletterem a cookies za osobu mladší 15 let musí udělit její zákonný zástupce."
      },
      {
        "type": "h2",
        "text": "9. Změny zásad"
      },
      {
        "type": "p",
        "text": "Zásady můžeme aktualizovat. Aktuální znění je vždy na www.vaseznacka.cz/ochrana-osobnich-udaju; o podstatných změnách vás informujeme e-mailem."
      },
      {
        "type": "p",
        "text": "Účinné od 03. 10. 2026."
      }
    ]
  },
  "cookies": {
    "title": "Cookies",
    "content": [
      {
        "type": "p",
        "text": "Bez souhlasu smíte na web ukládat jen nezbytné cookies; analytické a marketingové až po aktivním souhlasu (opt-in). Níže jsou hotové texty pro cookie lištu, panel nastavení a stránku Zásady používání cookies."
      },
      {
        "type": "h2",
        "text": "A) Text cookie lišty"
      },
      {
        "type": "p",
        "text": "Nadpis: Cookies na WINORWINS"
      },
      {
        "type": "p",
        "text": "Text: Používáme nezbytné cookies, aby e-shop fungoval. Se vaším souhlasem použijeme i analytické cookies, abychom věděli, co vás zajímá, a marketingové cookies, abychom vám mohli ukazovat relevantní reklamu na sociálních sítích a Googlu. Souhlas můžete kdykoli změnit v patičce webu v odkazu Nastavení cookies. Více v Zásadách používání cookies."
      },
      {
        "type": "p",
        "text": "Tlačítka (stejně velká a stejně výrazná): Přijmout vše · Odmítnout vše · Nastavení"
      },
      {
        "type": "h2",
        "text": "B) Panel „Nastavení cookies”"
      },
      {
        "type": "p",
        "text": "Úvodní text: Vyberte, které cookies můžeme používat. Nezbytné cookies nelze vypnout, bez nich by e-shop nefungoval."
      },
      {
        "type": "table",
        "rows": [
          [
            "Kategorie",
            "Popis v panelu",
            "Výchozí stav"
          ],
          [
            "Nezbytné",
            "Zajišťují základní funkce: košík, přihlášení, dokončení objednávky, zabezpečení a uložení vaší volby cookies.",
            "vždy zapnuto"
          ],
          [
            "Preferenční",
            "Pamatují si vaše volby, např. měnu, jazyk nebo naposledy prohlížené zboží.",
            "vypnuto"
          ],
          [
            "Analytické",
            "Pomáhají nám pochopit, jak web používáte, abychom ho mohli zlepšovat. Údaje vyhodnocujeme souhrnně.",
            "vypnuto"
          ],
          [
            "Marketingové",
            "Umožňují zobrazovat vám relevantní reklamu na Instagramu, Facebooku, TikToku a v síti Google a měřit její úspěšnost.",
            "vypnuto"
          ]
        ]
      },
      {
        "type": "p",
        "text": "Tlačítka: Uložit nastavení · Přijmout vše · Odmítnout vše"
      },
      {
        "type": "p",
        "text": "Odkaz v patičce webu (trvale): Nastavení cookies"
      },
      {
        "type": "h2",
        "text": "C) Zásady používání cookies"
      },
      {
        "type": "h3",
        "text": "Co jsou cookies"
      },
      {
        "type": "p",
        "text": "Cookies jsou malé textové soubory, které web ukládá do vašeho prohlížeče. Pomáhají, aby web fungoval, pamatoval si vaše volby a abychom mohli měřit návštěvnost a reklamu. Podobně fungují také pixely a jiné měřicí kódy; i na ně se tyto zásady vztahují."
      },
      {
        "type": "h3",
        "text": "Kdo cookies používá"
      },
      {
        "type": "p",
        "text": "Správcem je Dang Manh Nguyen, IČO 23161850, Chudenická 1059/30, Hostivař, 102 00 Praha 10, kontakt info@winorwins.com. Některé cookies ukládají třetí strany (Google, Meta, TikTok), které s nimi nakládají také podle svých zásad."
      },
      {
        "type": "h3",
        "text": "Právní základ"
      },
      {
        "type": "p",
        "text": "Nezbytné cookies používáme bez souhlasu podle § 89 odst. 3 zákona č. 127/2005 Sb., o elektronických komunikacích, protože bez nich nelze poskytnout službu, kterou jste si vyžádali. Ostatní cookies používáme jen s vaším souhlasem (čl. 6 odst. 1 písm. a) GDPR). Na měřicí služby Google používáme Google Consent Mode v2: bez vašeho souhlasu se analytické a reklamní cookies neukládají."
      },
      {
        "type": "h3",
        "text": "Přehled cookies"
      },
      {
        "type": "p",
        "text": "Tabulku upravte podle nástrojů, které na webu skutečně běží. Přesný seznam získáte skenerem cookies nebo z nástroje pro cookie lištu."
      },
      {
        "type": "table",
        "rows": [
          [
            "Název",
            "Poskytovatel",
            "Kategorie",
            "Účel",
            "Platnost"
          ],
          [
            "cc_cookie",
            "WINORWINS",
            "Nezbytné",
            "uložení vaší volby cookies",
            "6 měsíců"
          ],
          [
            "PHPSESSID",
            "WINORWINS",
            "Nezbytné",
            "relace, košík, přihlášení",
            "do zavření prohlížeče"
          ],
          [
            "cart",
            "WINORWINS",
            "Nezbytné / Preferenční",
            "obsah košíku, zvolená měna",
            "30 dní"
          ],
          [
            "_ga, gaID",
            "Google Analytics 4",
            "Analytické",
            "rozlišení návštěvníků, statistiky",
            "2 roky"
          ],
          [
            "_gcl_au",
            "Google Ads",
            "Marketingové",
            "měření konverzí z reklam",
            "3 měsíce"
          ],
          [
            "_fbp",
            "Meta (Facebook, Instagram)",
            "Marketingové",
            "zobrazování a měření reklam",
            "3 měsíce"
          ],
          [
            "_ttp",
            "TikTok",
            "Marketingové",
            "zobrazování a měření reklam",
            "13 měsíců"
          ],
          [
            "další, např. Hotjar, Klaviyo",
            "poskytovatel",
            "kategorie",
            "účel",
            "platnost"
          ]
        ]
      },
      {
        "type": "h3",
        "text": "Jak dlouho platí souhlas a jak ho změnit"
      },
      {
        "type": "p",
        "text": "Vaši volbu si pamatujeme 6 měsíců; poté se vás zeptáme znovu. Souhlas můžete kdykoli změnit nebo odvolat odkazem Nastavení cookies v patičce webu. Cookies můžete také smazat nebo zablokovat v nastavení prohlížeče; některé funkce e-shopu pak nemusí fungovat."
      },
      {
        "type": "h3",
        "text": "Předání mimo EU a vaše práva"
      },
      {
        "type": "p",
        "text": "Google, Meta a TikTok mohou údaje zpracovávat i mimo EU. Informace o předání a o vašich právech najdete v Zásadách ochrany osobních údajů."
      },
      {
        "type": "p",
        "text": "Účinné od 03. 10. 2026."
      }
    ]
  }
};
